import { DOCUMENT } from '@angular/common';
import { Component, OnInit, Inject, ViewChild, ElementRef } from '@angular/core';
import { HomepageService } from '../../services/homepage.service';
import { DirectoryService } from '../../services/directory.service';
import { AuthService } from '../../services/auth.service';
import { Router, ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { Title } from '@angular/platform-browser';
import { CookieService } from 'ngx-cookie-service';
import { NotifierService } from 'angular-notifier';
import { TenantService } from '../../services/tenant.service';

declare var google:any;

@Component({
  selector: 'app-default',
  templateUrl: './default.component.html',
  styleUrls: ['./default.component.css']
})
export class DefaultComponent implements OnInit {
  auth2: any;
  route: string;
  bannerText: string = '';
  locationCustom:boolean = false;
  libraryDirectory:boolean = false;
  googleLogin:boolean = false;
  currenturl:string = window.location.hostname;    
  nameSplit:any[] = this.currenturl.split(".");
  // Check if bare localhost or has a subdomain (e.g. pcs.localhost)
  isLocalhost:boolean = this.currenturl === 'localhost' || this.currenturl.endsWith('.localhost') || this.currenturl === '127.0.0.1';
  multiLocation:boolean = false;
  parameters:any = {
    'tenant' : '',
    'configuration' : '*',
  }
  error:string = '';
  microsoftSsoPending:boolean = false;
  microsoftSsoPendingMessage:string = 'Signing you in with Microsoft...';
  
  @ViewChild('loginRef') loginElement: ElementRef;
  //Themes needs to move to environment after finish
  private themes:any = {'default':'summertime', 'dark-theme':'luna', 'SleekAndRelaxed':'berry', 'violet-theme':'mochablue', 'kids1-theme':'birthdayCake', 'kids1-theme kids2-theme':'playground', 'kids1-theme christmas-theme':'christmas', 'kids1-theme beach-theme':'beach'};
  private readonly notifier: NotifierService;
  constructor( notifierService: NotifierService, private cookieService: CookieService, private authService: AuthService, private location: Location, private homepageService: HomepageService, @Inject(DOCUMENT) private document: Document, private router: Router, private titleService: Title,private routes: ActivatedRoute, private directoryService : DirectoryService, private tenantService: TenantService) {
    this.notifier = notifierService;
    
    this.titleService.setTitle('Opening');
    if(this.nameSplit.length == 1 || this.isLocalhost){
      //this.libraryDirectory = true;
      this.routes.queryParams.subscribe(params => {
        if(typeof(params.googleToken) == 'undefined'){
          //this.loginGoogleToken(params.googleToken);
          this.googleLogin = false;
          //this.titleService.setTitle('Google Login');
        }
        if( typeof(params.tenant) != 'undefined' ){
          this.googleLogin = true;
        }
      });
    }else if(this.nameSplit[0].toLowerCase() == 'library' && this.nameSplit[1].toLowerCase() == 'site'){
      this.libraryDirectory = true;
      this.titleService.setTitle('Library Directory');
    }else if(this.nameSplit[0].toLowerCase() == 'googlelogin'){
      this.googleLogin = true;
      this.titleService.setTitle('Google Login');
    }
    //this.googleLogin = true;
    //uncomment the next line to run OPAC library sites in locahost.
    //Comment while pushing. Increase app version to avoid cache issue.
    //this.libraryDirectory = false;

    //Checking library page to set banner.
    if(this.libraryDirectory == false){
      this.routes.queryParams.subscribe(params => {
        if(typeof(params.location) != 'undefined'){
          // Store redirect target without writing it into tenantLocId,
          // which would cause API calls to fire with a foreign location ID.
          this.redirectLocationId = params.location;
          this.locationCustom = true;
        }else if(this.isMicrosoftSsoCallback(params)){
          this.microsoftSsoPending = true;
          this.handleMicrosoftSsoCallback(params);
        }else if(typeof(params.googleToken) != 'undefined'){
          this.loginGoogleToken(params.googleToken);
        }else if(typeof(params.error) != 'undefined'){
          //this.error = params.error;
          
        }
      });
      router.events.subscribe((val) => {
        if(location.path() != ''){
          this.route = location.path();
          if(this.route.indexOf('/reading-lists') > -1){
             this.bannerText = 'Resource Lists';
          } else if(this.route.indexOf('/explore') > -1){
             this.bannerText = 'Explore';
          } else if(this.route.indexOf('/news') > -1){
             this.bannerText = 'Library News';
          } else if(this.route.indexOf('/new') > -1){
             this.bannerText = 'New in Library';
          } else if(this.route.indexOf('/unsubscribe') > -1){
            this.bannerText = 'Unsubscribe';
          } else if(this.route.indexOf('/recommended') > -1){
             this.bannerText = 'Recommended for You';
          } else if(this.route.indexOf('/popular') > -1){
             this.bannerText = 'Popular Titles';
          } else if(this.route.indexOf('/awards') > -1){
             this.bannerText = 'Awards & Honors';
          } else if(this.route.indexOf('/searchlist') > -1 || this.route.indexOf('/recentlist/') > -1){
             this.bannerText = 'Search Results';
          } else if(this.route.indexOf('/search') > -1){
             this.bannerText = 'Search Result';
          } else if(this.route.indexOf('/resources') > -1){
             this.bannerText = 'Resource Detail';
          } else if(this.route.indexOf('/resource/list') > -1){
             this.bannerText = '';
          } else if(this.route.indexOf('/account/resetpassword') > -1){
             this.bannerText = 'Reset Password';
          } else if(this.route.indexOf('/bulletins') > -1){
             this.bannerText = 'Bulletins';
          } else if(this.route.indexOf('/list/my') > -1){
             this.bannerText = 'My List';
          } else if(this.route.indexOf('/bulletin/') > -1){
             this.bannerText = 'Bulletin Detail';
          } else if(this.route.indexOf('/review/') > -1){
             this.bannerText = 'Review Detail';
          } else if(this.route.indexOf('/searchreview') > -1){
             this.bannerText = 'Review Search';
          } else if(this.route.indexOf('/my-account') > -1){
             this.bannerText = 'My Account';
          } else if(this.route.indexOf('/resetemail') > -1){
             this.bannerText = 'Update Email';
          }else if(this.route.indexOf('/home') > -1){
             this.route = 'Home';
          }else if(this.route.indexOf('/history') > -1){
             this.bannerText = 'History';
          }else if(this.route.indexOf('?error') > -1 || this.route.indexOf('?googleToken') > -1 || this.route.indexOf('?fbclid') > -1){
             this.route = 'Home';
          }else if(this.route.indexOf('location') > -1){
             this.multiLocation = true;
             this.route = 'Home';
          }
        } else {
          this.route = 'Home';
        }
      });
    }
  }

  settingLoad: boolean = false;
  countdown:number = 5;
  private redirectLocationId: string = '';
  ngOnInit() {
    var $this = this;
    //This is library directory.
    if(this.libraryDirectory == true){
      $('.loding-img-main').hide();
      if(this.cookieService.check('directoryLibName') && this.cookieService.check('directoryLibLink')){
        var name= this.cookieService.get('directoryLibName');
        var url = this.cookieService.get('directoryLibLink');
        setTimeout(function(){
          $('.searchLib').css({opacity:0,right:'1000px'})
          $('#dLibLink').attr('href', url);
          $('#goTitle').html(name);
          var html = '<div class="goLibrary-rightBtn"><img src="../../assets/images/btn-curve.png" alt="btn-curve.png"></div>';
          $('#dLibLink').html(name+html);
          
          var countdownNumberEl = document.getElementById('countdown-number');
          
          countdownNumberEl.textContent = $this.countdown.toString();
          setInterval(function() {
            if($this.countdown > 0){
              if($this.countdown == 1) window.location.href = url;
              $this.countdown = $this.countdown -1
              countdownNumberEl.textContent = $this.countdown.toString();  
            }
          }, 1000);

        },50);
      }else{
        setTimeout(function(){
          $('.goBox').hide();
          $('.searchBox').show();
          $('.goLib').css({opacity:0, right:'1000px'});
        },50);
      }
    }else{
      if(this.locationCustom == true){
        //getting the location specific library.
        this.goToLibrary();
      }else if(this.googleLogin == true){
        this.goToGoogle();
      }else{
        //loading library
        this.loadSetting();
        this.homepageService.setRegionalSettings().subscribe((regionalSetting)=>{
          //console.log('Run');
        });
      }
    }
  }

  //To get settings of lbrary.
  loadSetting(){  
  	return this.homepageService.getConfig().subscribe((data) => {
      if(data.data.settings.googleAnalytics.enabled){
        localStorage.setItem('googleAnalytics', data.data.settings.googleAnalytics.code);
        // Global site tag (gtag.js) - Google Analytics
        if(data.data.settings.googleAnalytics.code !== "" && data.data.settings.googleAnalytics.code !== null){
          const scriptUrl = `https://www.googletagmanager.com/gtag/js?id=${data.data.settings.googleAnalytics.code}`;
          const script = document.createElement('script');
          script.src = scriptUrl;
          document.head.appendChild(script);
        }
      }else{
        localStorage.removeItem('googleAnalytics');
      }
      var theme = data.data.settings.appearance.theme;
      if(theme.indexOf('custom') > -1){
        var customSplit=theme.split(' ');
        var name = customSplit[0];
        $('body').removeClass('kids1-theme beach-theme');
        $('body').removeClass('kids1-theme christmas-theme');
        $('body').removeClass('kids1-theme kids2-theme');
        $('body').removeClass('kids1-theme');
        $('body').removeClass('dark-theme');
        $('body').removeClass('SleekAndRelaxed');
        $('body').removeClass('violet-theme');
        $('body').removeClass('summertime');
        $('body').removeClass('default');
        $('body').removeClass('custom-theme');
        $('body').removeClass('custom-dark-theme');
        localStorage.setItem('theme', theme);
        this.homepageService.updateThemeName(name);
        $('body').addClass(name);
        document.documentElement.style.setProperty(`--first`, customSplit[1] );
        document.documentElement.style.setProperty(`--second`, customSplit[2] );
        document.documentElement.style.setProperty(`--third`, customSplit[3] );
        document.documentElement.style.setProperty(`--fourth`, customSplit[4] );
        document.documentElement.style.setProperty(`--fifth`, customSplit[5] );
      }else{
        var names = Object.keys(this.themes).find(key => this.themes[key] === theme);
        if(names){
          $('body').removeClass('kids1-theme beach-theme');
          $('body').removeClass('kids1-theme christmas-theme');
          $('body').removeClass('kids1-theme kids2-theme');
          $('body').removeClass('kids1-theme');
          $('body').removeClass('dark-theme');
          $('body').removeClass('SleekAndRelaxed');
          $('body').removeClass('violet-theme');
          $('body').removeClass('summertime');
          $('body').removeClass('default');
          $('body').removeClass('custom-theme');
          $('body').removeClass('custom-dark-theme');
          localStorage.setItem('theme', theme);
          this.homepageService.updateThemeName(theme);
          $('body').addClass(names);
        }else{
          localStorage.setItem('theme', 'summertime');
        }
      }
        if(!this.locationCustom){
          this.homepageService.setLocationId(data.data.settings.location.homeId);        
        }
        if(this.cookieService.check('loadedtenant') ){
          if(this.cookieService.get('loadedtenant') !=  data.data.tenantCode.toLowerCase()){
            this.cookieService.deleteAll('/');
            this.cookieService.delete('recentSearch');
            this.cookieService.delete('seachFor');
            this.cookieService.delete('recentSearchCunt');
            localStorage.removeItem('token');
            localStorage.removeItem('selectedResourcesIds');
          }
        } else if(this.cookieService.check('loadedtenantconfig') ){
          if(this.cookieService.get('loadedtenantconfig') !=  data.data.configCode){
            this.cookieService.deleteAll('/');
            this.cookieService.delete('recentSearch');
            this.cookieService.delete('seachFor');
            this.cookieService.delete('recentSearchCunt');
            localStorage.removeItem('token');
            localStorage.removeItem('selectedResourcesIds');
          }
        }

        this.cookieService.set('loadedtenant', data.data.tenantCode.toLowerCase(), 1,'/'); 
        this.cookieService.set('loadedtenantconfig' ,data.data.configCode, 1,'/');
        
        var key = 'selectedlocation'+data.data.tenantCode.toLowerCase();
        var locationId = this.homepageService.getLocationId();
        this.cookieService.set(key ,locationId, 1,'/'); 
        sessionStorage.setItem('lastSearchLocation',locationId);
  			this.settingLoad = true;
        this.titleService.setTitle(data.data.settings.appearance.banner.main.line2);
  	},(err) => {
      if(err.status == 500){
        this.router.navigate(['/error/internal']);
        } else if(err.status == 410 || err.status == 404) {
          this.router.navigate(['/error/nofound']);
        } 
      });
  }

  //To get the location specific library.
  goToLibrary(){
    this.homepageService.getLocationConfig(this.redirectLocationId).subscribe((response)=>{
        //This will send user to library this is necesary to reload page.
        window.location.href = 'https://'+response.data.url;
      },(error)=>{

      });
  }

  

  //To switch page from countdown to searching.
  findAnother(event){
    this.countdown = -1;
    event.preventDefault();
    var div = $(event.target).parents('.goBox');
    //console.log('I am clicked');
    $('.goBox').fadeOut(500);
    setTimeout(function(){
      $('.searchBox').fadeIn(500);
    },500);
    $('.goLib').animate({opacity:0, right:'1000px'},1000);
    $('.searchLib').animate({opacity:1, right:'0px'},1000);
  }

  //This will create autofill dropdown.
  finding(event){
  var text = $(event.target).val();
    //if(text.length > 1)
    if($.trim(text.toString()).length > 1){
      this.directoryService.getLibraryList(text).subscribe((data:any) => {
        //console.log(data, 'list');
        $('#opaclist').html('');
        data.forEach(arr=>{
          if(arr.active){
            $('#opaclist').append('<option value="'+arr.name+', '+arr.city+', '+arr.state+'" (click) = "createButton($event)" data-target="'+arr.url+'" data-name="'+arr.name+'" data-string="'+arr.name+', '+arr.city+', '+arr.state+'">');
          }
        })
      },
      (error) =>{
          //this is a keyup event so not alerting user.
      });
    }
  }

  //To create go to library button.
  createButton(event){
    var $this = this;
    var userText = $(event.target).val();
    $("#opaclist").find("option").each(function() {
      if ($(this).data('string') == userText) {
        $('.buttonGen').find('.btn-goLibrary').remove();
        var url = $(this).data('target');
        var name = $(this).data('name');
        var html = '<div class="btn-goLibrary mt-4"><div class="btn-goLibrary-inner">';
            html+= '<a class="btn btn-primary" href="'+url+'">'+name;
            html+= '<div class="goLibrary-rightBtn">';
            html+= "<img src='../../assets/images/btn-curve.png' alt='btn-curve.png'>";
            html+= '</div>';
            html+= '</a>';
            html+= '</div></div>';
        $('.buttonGen').append(html);
        $this.cookieService.set('directoryLibName', name, 1, '/');
        $this.cookieService.set('directoryLibLink', url, 1, '/');
        $(event.target).val('');
      }
    });
    
  }


  //Loading google SDK for google login.
  googleSDK() {
    //console.log(this.parameters);
    //if(this.parameters.tenant == 'thg' || this.parameters.tenant == 'THG'){
      //console.log("I am in new login");
      var $this = this;
      window.onload = function () {
        setTimeout(function(){
          $('#buttonDiv').find('#button-label').click();
        },8000);
        google.accounts.id.initialize({
          client_id: '1003925052394-fllpkk5hbvna7i5hif1hcimh08tqsatv.apps.googleusercontent.com',
          callback: $this.handleCredentialResponse
        });
        google.accounts.id.renderButton(
          document.getElementById("buttonDiv"),
          { 
            type: "standard",
            theme: "outline", 
            size: "large",
            width:"350px"
          }  // customization attributes
        );
        google.accounts.id.prompt(); // also display the One Tap dialog
      }
    // }else{
    //   console.log("I am in old login");
    //   window['googleSDKLoaded'] = () => {
    //     window['gapi'].load('auth2', () => {
    //       this.auth2 = window['gapi'].auth2.init({
    //         client_id: '1003925052394-fllpkk5hbvna7i5hif1hcimh08tqsatv.apps.googleusercontent.com',
    //         cookiepolicy: 'single_host_origin',
    //         scope: 'profile email'
    //       });
    //       this.prepareLoginButton();
    //       setTimeout(function(){
    //         document.getElementById("googleLoginButton").click();
    //       },3000);
    //     });
    //   }   
    //   (function(d, s, id){
    //     var js, fjs = d.getElementsByTagName(s)[0];
    //     if (d.getElementById(id)) {return;}
    //     js = d.createElement(s); js.id = id;
    //     js.src = "https://apis.google.com/js/platform.js?onload=googleSDKLoaded";
    //     fjs.parentNode.insertBefore(js, fjs);
    //   }(document, 'script', 'google-jssdk'));
    // }
  }

  //This will prepare google login button.
  prepareLoginButton() {
    var $this = this;
    window.onerror = function(message, source, lineno, colno, error) {
      if(error){
        $this.showError(error);
      }
    }
    var librarySite = this.parameters.tenant;
    if(this.parameters.config != '*'){
      librarySite += '-' + this.parameters.config;
    }
    librarySite += '.library.site';
    this.auth2.attachClickHandler(this.loginElement.nativeElement, {},
    (googleUser) => {
      librarySite += '?googleToken='+googleUser.getAuthResponse().access_token;
      window.location.href = 'https://'+librarySite;
    }, (error) => {
      $('.googleShow').removeClass('hide');
      if(error.error == 'popup_blocked_by_browser'){
        $('.googleErr').text("The Google login pop-up was blocked by your browser. Please enable pop-ups and try again.");
      }
    });
    
  }

  showError(error){
    if(error.error == 'idpiframe_initialization_failed'){
      $('.googleErr').text(error.details);
    }
  }

  goToGoogle(){
    $('.loding-img-main').hide();
    this.routes.queryParams.subscribe(params => {
      //if(typeof(params.tenant) != 'undefined'){
        console.log(params);
        this.cookieService.set('locationParams', JSON.stringify(params));
        this.parameters.tenant = params.tenant;
        this.parameters.config = params.config;
        console.log(this.parameters.tenant);
        this.googleSDK();
      // }else{
      //   this.parameters.tenant = 'thg';
      //   this.parameters.config = '*';
      //   this.googleSDK();
      // }
    });
  }

  //Login Through google token coming from googlelogin.library.site
  loginGoogleToken(token){
    this.authService.authGoogle(token).subscribe(data => {
      var locationId = this.homepageService.getLocationId(); 
      localStorage.setItem('token', data.access_token); 
      localStorage.setItem('refreshToken', data.refresh_token);
      if( localStorage.getItem('selectedResourcesIds') != null ) {
        var selectedResourcesIds = JSON.parse(localStorage.getItem('selectedResourcesIds'));
        this.homepageService.saveMyList(data.access_token, selectedResourcesIds).subscribe(addTempIds => {
          this.cookieService.delete('tempPersonalCollection');
          this.getProfileDetail(data.access_token,locationId);
         });
      } else {
        this.getProfileDetail(data.access_token,locationId);
      }
    },(error) =>{
       //this.notifier.notify('error', "Something isn't working as expected.");
       //console.log(error);
       //this.notifier.notify('error', error.error.error_description);
       this.error = error.error.error_description;
       this.notifier.notify('error', 'Invalid Login');
       this.router.navigate(['']);
    });
  }

  isMicrosoftSsoCallback(params){
    const expectedState = localStorage.getItem('ms_sso_state');
    const hasOAuthData = typeof(params.code) != 'undefined' || typeof(params.id_token) != 'undefined';
    return hasOAuthData && expectedState != null;
  }

  clearMicrosoftSsoState(){
    localStorage.removeItem('ms_sso_state');
    localStorage.removeItem('ms_sso_nonce');
    localStorage.removeItem('ms_sso_code_verifier');
    localStorage.removeItem('ms_sso_redirect_uri');
  }

  handleMicrosoftSsoCallback(params){
    this.microsoftSsoPending = true;
    const expectedState = localStorage.getItem('ms_sso_state');
    if(expectedState && params.state !== expectedState){
      this.clearMicrosoftSsoState();
      this.microsoftSsoPending = false;
      this.notifier.notify('error', 'Microsoft login could not be validated. Please try again.');
      this.router.navigate([], { queryParams: {}, replaceUrl: true });
      return;
    }

    if(typeof(params.error) != 'undefined'){
      this.clearMicrosoftSsoState();
      this.microsoftSsoPending = false;
      this.notifier.notify('error', params.error_description || 'Microsoft login failed.');
      this.router.navigate([], { queryParams: {}, replaceUrl: true });
      return;
    }

    const idToken = params.id_token || '';
    const authCode = params.code || '';
    const codeVerifier = localStorage.getItem('ms_sso_code_verifier') || '';
    const redirectUri = localStorage.getItem('ms_sso_redirect_uri') || window.location.origin;

    this.authService.authMicrosoft(idToken, authCode, codeVerifier, redirectUri).subscribe((data:any) => {
      if(!data || !data.access_token){
        this.clearMicrosoftSsoState();
        this.microsoftSsoPending = false;
        this.notifier.notify('error', 'Microsoft login failed.');
        this.router.navigate([], { queryParams: {}, replaceUrl: true });
        return;
      }

      var locationId = this.homepageService.getLocationId();
      localStorage.setItem('token', data.access_token);
      if(data.refresh_token){
        localStorage.setItem('refreshToken', data.refresh_token);
      }
      this.clearMicrosoftSsoState();
      this.router.navigate([], { queryParams: {}, replaceUrl: true });

      if( localStorage.getItem('selectedResourcesIds') != null ) {
        var selectedResourcesIds = JSON.parse(localStorage.getItem('selectedResourcesIds'));
        this.homepageService.saveMyList(data.access_token, selectedResourcesIds).subscribe(addTempIds => {
          this.cookieService.delete('tempPersonalCollection');
          this.getProfileDetail(data.access_token,locationId, () => {
            this.microsoftSsoPending = false;
          }, () => {
            this.microsoftSsoPending = false;
          });
         });
      } else {
        this.getProfileDetail(data.access_token,locationId, () => {
          this.microsoftSsoPending = false;
        }, () => {
          this.microsoftSsoPending = false;
        });
      }
    }, (error) => {
      this.clearMicrosoftSsoState();
      this.microsoftSsoPending = false;
      this.error = error && error.error && error.error.error_description ? error.error.error_description : 'Microsoft login failed';
      this.notifier.notify('error', 'Invalid Login');
      this.router.navigate([], { queryParams: {}, replaceUrl: true });
    });
  }

  //handling response coming from googlelogin.library.site.
  handleCredentialResponse(response) {
    //console.log(parameters);
    console.log("Response coming from Google Login:" + JSON.stringify(response));
    console.log((window.location.href.split('?')[1]).split('&')[0].split('=')[1]);
    var librarySite = (window.location.href.split('?')[1]).split('&')[0].split('=')[1];
    if((window.location.href.split('?')[1]).split('&')[1].split('=')[1] != '*'){
      librarySite += '-' + (window.location.href.split('?')[1]).split('&')[1].split('=')[1];
    }
    librarySite += '.library.site';
    //var librarySite = 'thg.library.site';
    librarySite += '?googleToken='+response.credential;
    console.log(librarySite);
    window.location.href = 'https://'+librarySite;
  }

  //Getting Profile details of user
  getProfileDetail(access_token,locationId, onSuccess?: () => void, onError?: () => void){
    this.authService.getProfileDetail(access_token,locationId).subscribe(profile => {
    //this.cookieService.set( 'info', JSON.stringify({'token' : access_token,'detail' :  profile.data }), 1,'/');
    var auth = localStorage.getItem('token');
    localStorage.setItem('info', JSON.stringify({'token' : auth , 'detail' :  profile.data })); 
    this.cookieService.set( 'patron', 'true', 1,'/');
    this.cookieService.set( 'patronPermissions', JSON.stringify(profile.data.permission), 1,'/');
    this.cookieService.set( 'userDetail', JSON.stringify({'patronId': profile.data.patronId,'firstName': profile.data.firstName,'lastName': profile.data.lastName, 'email': profile.data.email}), 1,'/');
    $('li#loginLi').removeClass('show').addClass('hide');
    if(profile.data.profilePicture != '') {           
      $('li#profileLi').find('img').attr('src',profile.data.profilePicture).removeClass('hide').addClass('show');
    } else {
      $('li#profileLi').find('img').addClass('hide');
    }          
    $('li#profileLi').find('span').text(profile.data.firstName).removeClass('hide').addClass('show');
    $('li#profileLi').addClass('show').removeClass('hide');
    $('#Publish-My-List').addClass('show').removeClass('hide');
    $('li#myCollectionLi').addClass('show').removeClass('hide');
    if(profile.data.permission.opacAdmin){
      this.document.body.classList.add('login-patron');            
    }
    localStorage.setItem('selectedResourcesIds', JSON.stringify(profile.data.personalListResourceIds));          
    this.cookieService.set( 'MyLIstCount', profile.data.totalMyListCount, 1,'/');
    if(profile.data.totalMyListCount > 0 ){
      $('a.onViewList').removeClass('hide').addClass('show');
      $('#Publish-My-List').removeClass('hide').addClass('show');
    }
    $('#myCollectionLi').find('span.count').text(profile.data.totalMyListCount);
    var self = this;
    setTimeout(function(){
      if(onSuccess){
        onSuccess();
      }
      self.router.navigate(['']);
    }, 500);
  }, () => {
    if(onError){
      onError();
    }
  });
  }

  goBack(){
    var librarySite = this.parameters.tenant;
    if(this.parameters.config != '*'){
      librarySite += '-' + this.parameters.config;
    }
    librarySite += '.library.site?error=googleLoginAborted';
    //librarySite = "localhost:4200/?error=no";
    window.location.href = 'http://'+librarySite;
  }
} 